import { memo } from "react";
import {
  Box,
  Button,
  Typography,
  styled,
} from "@mui/material";

// ─── Styled Components ───────────────────────────────────────────────────────

const SectionCard = styled(Box)({
  backgroundColor: "white",
  borderRadius: "0.75rem",
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  padding: "1.5rem",
  marginBottom: "1.5rem",
});

const SectionTitle = styled(Typography)({
  fontSize: "1.125rem",
  fontWeight: 700,
  color: "#1e293b",
  marginBottom: "1rem",
});

const ActionButton = styled(Button)({
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.875rem",
  padding: "10px 24px",
  borderRadius: "9999px",
});

const PrimaryButton = styled(ActionButton)({
  backgroundColor: "#f382a0",
  color: "white",
  "&:hover": { backgroundColor: "#c75578" },
  "&:disabled": { backgroundColor: "#94a3b8" },
});

// ─── Component ───────────────────────────────────────────────────────────────

const CardMeGenFinalVideoScript = memo(
  (props: { videoUrl: string; onGenerateVideo: () => void }) => {
    if (!props.videoUrl) return null;
    return (
      <SectionCard id="megen-gen-script-final-video-card">
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: "1rem" }}>
          <SectionTitle>Final Output</SectionTitle>
          <PrimaryButton id="megen-gen-script-regenerate-video-btn" onClick={props.onGenerateVideo} sx={{ backgroundColor: "#f382a0" }}>
            สร้างวิดีโอใหม่
          </PrimaryButton>
        </Box>
        <Box
          id="megen-gen-script-final-video-player"
          component="video"
          controls
          src={props.videoUrl}
          sx={{ width: "100%", borderRadius: "0.5rem", backgroundColor: "black", aspectRatio: "16/9" }}
        />
      </SectionCard>
    );
  }
);

export default CardMeGenFinalVideoScript;
